import React from 'react';
import PropTypes from 'prop-types';

import FieldRadio from '../../fields/fieldRadio/FieldRadio';
import ChannelPrice from '../../../containers/channelUtils/ChannelPrice';

export default function RadioGroupVariantPicker({availableVariants, selectedVariant, onChange}) {
  return (
    <div className="product__options">
      {availableVariants.sort((a, b) => a.position - b.position).map(variant => (
        <FieldRadio
          key={variant.id}
          className="field-radio--option"
          input={{
            value: variant.id,
            checked: variant.id === selectedVariant.id,
            onChange: () => onChange(variant)
          }}
        >
          <span className="product__option-text">{variant.name}</span>

          {variant.price !== null && (
            <ChannelPrice
              className="product__option-price"
              price={variant.price}
            />
          )}
        </FieldRadio>
      ))}
    </div>
  );
}

RadioGroupVariantPicker.propTypes = {
  availableVariants: PropTypes.array.isRequired,
  selectedVariant: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./components/productPurchase/variantPickers/RadioGroupVariantPicker.js